var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-pin-2107065",
    transform: "translate(-73.034 -73.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_195",
    "data-name": "Union 195",
    d: "M.167,17.836a.568.568,0,0,1,0-.8l4.887-4.885L1.8,8.89a.829.829,0,0,1,.1-1.262,5.469,5.469,0,0,1,3.011-.9,5.4,5.4,0,0,1,1.736.289l4.638-4.087A4.706,4.706,0,0,1,11.5.542a.831.831,0,0,1,.6-.522A.846.846,0,0,1,12.284,0a.824.824,0,0,1,.586.243l4.887,4.889a.822.822,0,0,1,.224.762.83.83,0,0,1-.521.6,4.573,4.573,0,0,1-1.6.284,4.6,4.6,0,0,1-.789-.067l-4.087,4.64a5.53,5.53,0,0,1-.607,4.744.832.832,0,0,1-.608.346c-.022,0-.046,0-.068,0a.829.829,0,0,1-.586-.243L5.856,12.948.969,17.836a.571.571,0,0,1-.8,0Zm2.71-9.473,6.76,6.762a4.36,4.36,0,0,0,.17-3.675l-.033-.082.075-.444,4.644-5.27.422-.132L15,5.54a3.537,3.537,0,0,0,.861.1,3.576,3.576,0,0,0,.732-.075L12.432,1.411A3.573,3.573,0,0,0,12.46,3l.021.083-.132.424L7.077,8.153l-.443.075-.081-.034A4.354,4.354,0,0,0,4.9,7.862,4.446,4.446,0,0,0,2.876,8.362Z",
    transform: "translate(73.034 73.025)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.f00a23871bbf1db26302ee51b1988d65.svg";
export { ForwardRef as ReactComponent };